// gatsby-browser.tsx

import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import { MDXProvider } from '@mdx-js/react';
import { LanguageProvider } from './src/contexts/LanguageContext';
import { ThemeProvider } from './src/contexts/ThemeContext';
import { MDXComponents } from './src/components/blog/templates/MDXComponents';
import './src/styles/global.css';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <MDXProvider components={MDXComponents}>
          {element}
        </MDXProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};